export const conflictingSources: string[] = [
  'One manual explains equipment.',
  'Another document covers fireground operations.',
  'A video demonstrates a procedure.',
  'A separate resource contains a few training exercises.',
]

export const symptoms: string[] = [
  'And when your next training session arrives...',
  'You’re still trying to put everything together.',
]

export const needsList: string[] = [
  'You need a clear explanation.',
  'You need a useful diagram.',
  'You need an exercise your students can understand.',
  'You need a structured progression.',
  'And you need a way to evaluate what they’ve learned.',
]

export const searchQuestions: string[] = [
  'What should I teach today?',
  'Where can I find complete firefighter training material?',
  'How do I explain complex procedures more clearly?',
  'What practical exercises can I use with my students?',
  'How do I organize beginner and advanced training?',
  'Where can I find professional diagrams and reference materials?',
  'How can I stop repeating the same lessons?',
  'How do I evaluate student progress?',
  'How can I prepare better training without losing hours every week?',
]

export const painPoints: string[] = [
  'Hours spent searching for suitable teaching material.',
  'Preparing each lesson from scratch.',
  'Repeating the same exercises because finding new ones takes too long.',
  'Using text-heavy manuals that are difficult to explain to students.',
  'Trying to teach complex concepts without clear visual references.',
  'Organizing scattered documents and resources.',
  'Developing training scenarios independently.',
  'Struggling to adapt activities for different experience levels.',
  'Creating assessments without a consistent structure.',
  'Losing valuable preparation time.',
  'And constantly wondering whether you have enough material for your next training session.',
]

export const systemShows: string[] = [
  'WHAT TO TEACH.',
  'WHAT TO SHOW.',
  'HOW TO EXPLAIN IT.',
  'HOW TO ORGANIZE THE SESSION.',
  'WHAT ERRORS TO IDENTIFY.',
  'HOW TO ASSESS PROGRESS.',
]
